import(/* webpackMode: "eager" */ "/home/site/web/sapient.pro/private/sapientpro-frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/page-components/Vacancies/Vacancies.tsx");
